import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { useServicesStore } from "@/stores/useServicesStore";
export const useCartItem = itemId => {
  const $ = _c(9);
  const cartClient = useServicesStore(_temp);
  let t0;
  if ($[0] !== itemId) {
    t0 = ["cartItem", itemId];
    $[0] = itemId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== cartClient || $[3] !== itemId) {
    t1 = async () => {
      if (!cartClient || !itemId) {
        return;
      }
      return cartClient.getCartItem(itemId);
    };
    $[2] = cartClient;
    $[3] = itemId;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const t2 = !!itemId && !!cartClient;
  let t3;
  if ($[5] !== t0 || $[6] !== t1 || $[7] !== t2) {
    t3 = {
      queryKey: t0,
      queryFn: t1,
      enabled: t2,
      staleTime: Infinity
    };
    $[5] = t0;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return useQuery(t3);
};
function _temp(state) {
  return state.cartClient;
}